import { render, staticRenderFns } from "./CustomExpansionPanel.vue?vue&type=template&id=2db86a45&scoped=true&"
import script from "./CustomExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./CustomExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./CustomExpansionPanel.vue?vue&type=style&index=0&id=2db86a45&lang=scss&scoped=true&"
import style1 from "./CustomExpansionPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db86a45",
  null
  
)

export default component.exports